import React, { Component, lazy, Suspense } from "react";
import { Link, Route, Switch, BrowserRouter as Router, Redirect } from "react-router-dom";
import { isMobileApp } from "@/utils/MobileAppUserAgentChecker"

import { mode } from "webconfig"
import ReactGA from 'react-ga'
// import ReactPixel from 'react-facebook-pixel'

import i18n from '@/i18n'

import Loading from '@/_mobile/Loading/Loading'
import Footer from '@/_mobile/Make/Footer/Footer';
import OverlayUI from '@/_mobile/OverlayUI'

import '@/_mobile/Gallery/SlideUpDialog/SlideUpDialog.scss'

const MobileMake = lazy(() => import("@/_mobile/Routers/mobileMake"))
const MobileLogin = lazy(() => import("@/_mobile/Routers/mobileLogin"))
const MobileMyVideo = lazy(() => import("@/_mobile/Routers/mobileMyVideo"))
const MobileGallery = lazy(() => import("@/_mobile/Routers/mobileGallery"))
const MobileUserGallery = lazy(() => import("@/_mobile/Routers/mobileUserGallery"))
const MobileShare = lazy(() => import("@/_mobile/Routers/mobileShare"))
const MobileJoin = lazy(() => import("@/_mobile/Routers/mobileJoin"))
const MobileMyPage = lazy(() => import("@/_mobile/Routers/mobileMyPage"))
const MobileEventPage = lazy(() => import("@/_mobile/Routers/mobileEventPage"))
const MobileTutorial = lazy(() => import("@/_mobile/Routers/mobileTutorial"))
const MobileShop = lazy(() => import("@/_mobile/Routers/mobileShop"))
const MobilePaidResult = lazy(() => import("@/_mobile/Routers/mobilePaidResult"))
const MobileAdminNotiClicked = lazy(() => import("@/_mobile/Routers/mobileAdminNotiClicked"))
const MobileDuplicated = lazy(() => import("@/_mobile/Routers/mobileDuplicated"))
const MobilePointShop = lazy(() => import('@/_mobile/Routers/mobilePointShop'))
const MobileNotifications = lazy(() => import('@/_mobile/Routers/mobileNotifications'))
const MobileSocialWithdraw = lazy(() => import('@/_mobile/Routers/mobileSocialWithdraw'))
const MobileDeleteAccountGuide = lazy(() => import('@/_mobile/DeleteAccountGuide'))
const MobileAiTool = lazy(() => import('@/_mobile/Routers/mobileAiTool'))
const MobileWorkspace = lazy(() => import('@/_mobile/Workspace/Workspace'))
const Interface = lazy(() => import('@/_mobile/Interface/Interface'))
const MobileNewLanding2025 = lazy(() => import('@/_mobile/NewLanding2025'))
const MobileYoutubeShorts = lazy(() => import('@/_mobile/YoutubeShorts'))

class VideomonsterMobileRouter extends Component {

    currentLocation
    isMobileApp = isMobileApp()
    notRenderHeaderPath = [
        '/login',
        '/tutorial'
    ]
    renderFooterPath = [
        '/make',
        '/ai-tool/select',
        '/myVideo',
        '/share',
        '/gallery',
        '/user-gallery',
        '/myPage/checkpassword',
        '/myPage/settingaccount',
        '/myPage/order',
        '/myPage/likedvideo',
        '/myPage/orderhistory',
        '/myPage/notice',
        '/event',
        '/myPage/mygallery',
        '/shop',
        '/point-shop'
    ]

    IsRenderHeader = () => {
        const { pathname } = window.location

        for (let i = 0; i < this.notRenderHeaderPath.length; i++) {
            if (pathname.toLowerCase().startsWith(this.notRenderHeaderPath[i].toLowerCase())) return false
        }
        return true
    }

    IsRenderFooter = () => {
        const { pathname } = window.location

        if(!this.isMobileApp) return false;

        if (pathname === '/') return true
        for (let i = 0; i < this.renderFooterPath.length; i++) {
            if (pathname.toLowerCase().startsWith(this.renderFooterPath[i].toLowerCase())) return true
        }
        return false
    }

    ForceUpdate = () => this.forceUpdate()

    listenLocationChange(props) {
        if (this.currentLocation !== props.location.pathname.split('/')[1]) {
            this.currentLocation = props.location.pathname.split('/')[1]

            if (mode === 'stage') {
                ReactGA.pageview('/' + props.location.pathname.split('/')[1])
                // ReactPixel.pageView('/' + props.location.pathname.split('/')[1])
            }
        }
    }

    renderRouteList =() => {
        if(isMobileApp()) {
            return (
                <Switch>
                    <Route exact path={`/`} component={props => { this.listenLocationChange(props); return <MobileNewLanding2025 {...props} /> }} />
                    <Route path={`/login`} component={props => { this.listenLocationChange(props); return <MobileLogin {...props} /> }} />
                    <Route path={`/tutorial`} component={props => { this.listenLocationChange(props); return <MobileTutorial {...props} /> }} />
                    <Route path={`/make`} component={props => { this.listenLocationChange(props); return <MobileMake {...props} /> }} />
                    <Route path={`/myVideo`} component={props => { this.listenLocationChange(props); return <MobileMyVideo {...props} /> }} />
                    <Route path={`/share`} component={props => { this.listenLocationChange(props); return <MobileShare {...props} /> }} />
                    <Route path={'/ai-tool'} component={props => {this.listenLocationChange(props); return <MobileAiTool {...props} />}}/>
                    <Route path={`/gallery`} component={props => { this.listenLocationChange(props); return <MobileGallery {...props} /> }} />
                    <Route path={`/user-gallery`} component={props => { this.listenLocationChange(props); return <MobileUserGallery {...props} /> }} />
                    <Route path={`/join`} component={props => { this.listenLocationChange(props); return <MobileJoin {...props} /> }} />
                    <Route path={`/myPage`} component={props => { this.listenLocationChange(props); return <MobileMyPage {...props} /> }} />
                    <Route path={`/event`} component={props => { this.listenLocationChange(props); return <MobileEventPage {...props} /> }} />
                    <Route path={`/shop`} component={props => { this.listenLocationChange(props); return <MobileShop {...props} /> }} />
                    <Route path={`/socialwithdraw`} component={props => { this.listenLocationChange(props); return <MobileSocialWithdraw {...props} /> }} />
                    <Route path={`/socialnotfound`} component={props => { this.listenLocationChange(props); return <MobileSocialWithdraw {...props} /> }} />
                    <Route path={`/paid-result`} component={props => <MobilePaidResult {...props} />} />
                    <Route path={`/noti-clicked`} component={props => <MobileAdminNotiClicked {...props} />} />
                    <Route path={`/duplicated`} component={props => <MobileDuplicated {...props} />} />
                    <Route path={`/notifications`} component={props => <MobileNotifications {...props} />} />
                    <Route path={'/delete-account-guide'} component={() => <MobileDeleteAccountGuide />} />
                    {/* Redirect */}
                    <Route path={`/Tos`} component={() => <Redirect to={`/myPage/tos`} />} />
                    <Route path={`/Privacy`} component={() => <Redirect to={`/myPage/privacy`} />} />
                    <Route path={`/Copyright`} component={() => <Redirect to={`/myPage/copyright`} />} />
                    <Route path={`/ai-product-term`} component={() => <Redirect to={`/myPage/ai-product-term`} />} />

                    <Route path={`/workspace`} component={props => { this.listenLocationChange(props); return <MobileWorkspace {...props} /> }} />
                    <Route path={`/youtube-shorts`} component={props => { this.listenLocationChange(props); return <MobileYoutubeShorts {...props} /> }} />

                    <Route path={`/useguide`} component={() => <Redirect to={`/myPage/guide`} />} />
                    <Route path={`/payment`} component={() => <Redirect to={`/shop`} />} />

                    <Route path={`/user/*/my-video`} component={() => <Redirect to={`/myVideo`} />} />
                    <Route path={`/user/*/account-setting`} component={() => <Redirect to={`/myPage/checkpassword`} />} />
                </Switch>
            )
        } else {
            return (
                <Switch>
                    <Route exact path={`/`} component={props => { this.listenLocationChange(props); return <MobileNewLanding2025 {...props} /> }} />
                    <Route path={`/shop`} component={props => { this.listenLocationChange(props); return <MobileShop {...props} /> }} />
                    <Route path={`/gallery`} component={props => { this.listenLocationChange(props); return <MobileGallery {...props} /> }} />

                    <Route path={`/myPage`} component={props => { this.listenLocationChange(props); return <MobileMyPage {...props} /> }} />
                    <Route path={'/delete-account-guide'} component={() => <MobileDeleteAccountGuide />} />
                    {/* Redirect */}
                    <Route path={`/Tos`} component={() => <Redirect to={`/myPage/tos`} />} />
                    <Route path={`/Privacy`} component={() => <Redirect to={`/myPage/privacy`} />} />
                    <Route path={`/Copyright`} component={() => <Redirect to={`/myPage/copyright`} />} />
                    <Route path={`/ai-product-term`} component={() => <Redirect to={`/myPage/ai-product-term`} />} />

                    <Route component={() => <Redirect to={`/`} />} />
                </Switch>
            )
        }
    }

    render() {
        const { match, history } = this.props;
        return (
            <Suspense fallback={
                <>
                    {
                        this.IsRenderHeader() &&
                        <header
                            style={{
                                height: 50,
                                width: '100vw',
                                borderBottom: 'border-bottom: 1px solid var(--color-box-border)',
                                zIndex: 100,
                                backgroundColor: 'var(--color-primary)'
                            }}
                        />
                    }
                    <div style={{ width: '100vw', height: 'calc(100vh - 120px)', color: 'var(--color-background)', paddingBottom: 120 }}>
                        <Loading componentName={i18n.t("mobile.loading")} />
                    </div>
                    {
                        this.IsRenderFooter() &&
                        <Footer {...this.props} />
                    }
                </>
            }>
                <Interface history={history} ForceUpdate={this.ForceUpdate} />
               {this.renderRouteList()}
               <OverlayUI />
            </Suspense>
        );
    }
}

export default VideomonsterMobileRouter